import React, { useEffect } from "react";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import ContestSummary from "@/pages/ContestSummary";

// Public landing for a scanned flyer QR. Routes based on sign-in state:
//  - guest        -> public Contest Summary (with a Register CTA -> become a member)
//  - member (no license) -> BR License activation, then back to this event
//  - member (licensed)   -> Calendar focused on this event, ready to Register
export default function EventEntry() {
  const { id } = useParams();
  const { user } = useAuth();
  const navigate = useNavigate();
  const [sp] = useSearchParams();
  const ref = sp.get("ref") || "";   // Racing Team code baked into a shared flyer

  useEffect(() => {
    if (user === null || user === false) return; // checking or guest
    if (!user.has_license) navigate(`/license?next=/e/${id}`, { replace: true });
    else navigate(`/calendar?event=${id}`, { replace: true });
  }, [user, id, navigate]);

  if (user === null) return <div className="text-center text-race-sub py-20">Loading event…</div>;
  if (user === false) return <ContestSummary id={id} refCode={ref} />;
  return <div className="text-center text-race-sub py-20">Taking you to the race…</div>;
}
